import script from "./TabSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TabSearch.vue?vue&type=script&setup=true&lang=ts"

import "./TabSearch.vue?vue&type=style&index=0&id=375c05bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-375c05bc"]])

export default __exports__